import { DataFieldType } from "../../../../shared/types/dataField";

export const hasDataFieldOptions = (type: DataFieldType | undefined) =>
	type
		? [
				DataFieldType.MULTI_SELECT_FIELD,
				DataFieldType.SELECT_FIELD,
				DataFieldType.RADIO,
				DataFieldType.CHECKBOX_GROUP,
			].includes(type)
		: false;

export const hasPlaceholder = (type: DataFieldType | undefined): boolean => {
	return type ? [DataFieldType.RADIO, DataFieldType.CHECKBOX, DataFieldType.CHECKBOX_GROUP].includes(type) : false;
};
